<template>
 <div class="">
    <div v-if="errorStatus" class="alert alert-danger my-3" role="alert" v-html="errorStatus">
    </div>
    <div v-else-if="isLoading" class="d-flex align-items-center justify-content-center" style="min-height:300px">
        <div class="spinner-border mx-2" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        Loading...
    </div>
    <div v-else-if="noData">
      <div v-if="errorStatus" class="alert alert-info my-3" role="alert">
        No data available.
      </div>
    </div>
    <div v-else-if="!selectedLocation" class="row justify-content-md-center">
      <div class="col-12 col-lg-8 ">
        <h5>Please add a location to get started</h5>
        <div class="input-group">
          <div class="btn px-1 disabled" >
            <i class="bi bi-geo"></i>
          </div>
          <input v-model="newLocation" v-on:keyup.enter="setLocation()" class="form-control border-end-0  border-primary" type="text" placeholder="Enter a location" aria-describedby="locationHelpBlock">
          <span class="input-group-append">
              <button @click="setLocation()" class="btn btn-primary  border-start-0 border-primary ms-n1" :class="{disabled:!newLocation}" type="button" >
                  <i class="bi bi-search"></i>
              </button>
          </span>
        </div>
      </div>
    </div>
    <div v-else class="row justify-content-md-center">
      <div class="col-12 col-lg-10 ">
        <div class="d-flex align-items-center">
          <h3 class="h3">Models Dashboard for
            <VcLocationChooser 
              :selectedLocation="selectedLocation"
              @location-selected="setLocation" />
            <DateRangeChooser v-if="showDateRangeChooser" :queryDefinition="queryDefn" :queryData="queryData" @change:daterange="setDateRange" />
          </h3> 
        </div>
        <h5>Query parameters</h5>
        <div class="row">
          <div class="mb-3 col-1">
            <input type="text" class="form-control form-control-sm" placeholder="unitGroup"  v-model="queryDefn.unitGroup"  >
            <small class="form-text text-muted">UnitGroup</small>
          </div>
          <div class="mb-3 col-2">
            <input type="text" class="form-control form-control-sm" placeholder="Include"  v-model="queryDefn.include"  >
            <small class="form-text text-muted">Include</small>
          </div>
          <div class="mb-3 col-2">
            <input type="text" class="form-control form-control-sm" placeholder="Options"  v-model="queryDefn.options"  >
            <small class="form-text text-muted">Options</small>
          </div>
          <div class="mb-3 col-4">
            <textarea  class="form-control form-control-sm" placeholder="Elements"  v-model="queryDefn.elements"  rows="2"></textarea>
            <small class="form-text text-muted">Elements</small>
          </div>
          
          <div class="mb-3 col-1">
             <button type="submit" class="btn btn-primary btn-sm" @click="refreshData()">Submit</button>
          </div>
        </div>

        <h5>View options</h5>
        <div class="row mb-3">
          <div class="col-2">
            <select class="form-select form-select-sm" v-model="showBy" >
              <option value="model">Model</option>
              <option value="element">Element</option>
            </select>
            <small class="form-text text-muted">Show by</small>
          </div>
          <div  v-if="showBy==='element'" class="col-2">
            <select class="form-select form-select-sm" v-model="viewElement" >
              <option  v-for="elementTable in elementTables" :value="elementTable">{{elementTable.element}}</option>
            </select>
            <small class="form-text text-muted">Show by</small>
          </div>
        </div>
        <h5>Chart</h5>
        <div class="d-flex mb-3 comparisonchart"  >
            <div class="tooltip"><div class="contents">-</div></div>
            <div class="legend" ></div>
            <svg class="w-100" style="min-height:400px"></svg>
        </div>



        <template v-if="showBy==='model'">
          <div v-for="table in tables"  >
            <template v-if="table && table.model">
            <h5>{{table.model.id}}</h5>
            <table class="table table-striped table-sm fs-xs">
              <thead>
              <tr><th v-for="col in columns">{{col}}</th></tr>
              </thead>
              <tbody>
                <tr v-for="d in tableRows(table)">
                  <td v-for="col in columns">{{d[col]}}</td>
                </tr>
              </tbody>
            </table>
            </template>
          </div>  
        </template>
        <template v-if="showBy==='element' && viewElement">
         <!-- <div v-for="elementTable in elementTables">-->
            <h5>{{viewElement.element}}</h5>
            <table class="table table-striped table-sm fs-xs elementTable">
             
              <thead>
                <tr>
                  <th>Date</th>
                  <th v-for="model in viewElement.models" ><div class="text-nowrap">{{model?.model?.id}}</div></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Max</th>
                   <td v-for="model in viewElement.models" >{{format(model['max'])}}</td>
                </tr>
                <tr>
                  <th>Min</th>
                  <td v-for="model in viewElement.models" >{{format(model['min'])}}</td>
                </tr>
                <tr v-if="showSum(viewElement.element)">
                  <th>Sum</th>
                  <td v-for="model in viewElement.models" >{{format(model['sum'])}}</td>
                </tr>
                <tr>
                  <th>Mean</th>
                  <td v-for="model in viewElement.models" >{{format(model['sum']/model['count'])}}</td>
                </tr>
                
               
                <tr v-for="d in viewElement.dates">
                  <th class="text-nowrap">{{formatEpochTime(d)}}</th>
                  <td v-for="model in viewElement.models" >{{format(model[d])}}</td>
                </tr>
              </tbody>
            
            </table>

         <!-- </div>-->
        </template>
      </div>
    </div>
    <CommonModals />
  </div>
</template>

<script>
import {VcLocationsStorage} from "/src/visualcrossing-core/vclocationsstorage";
import "/src/visualcrossing-core/vccommunicator_serveradmin";
import CommonModals from '/src/components/CommonModals.vue'
import {VcDateUtils} from "/src/visualcrossing-core/vcdateutils";
import DateRangeChooser from '/src/components/DateRangeChooser.vue';
import * as d3 from "d3";
export default {
  name: 'loadermonitor',
  props: {
    
  },
  data() {
    return {
      noData:false,
      sessionId:null,
      sessionState:null,
      errorStatus:null,
      isLoading:false,
      selectedLocation:null,
      viewElement:null,
      //rooturl:null,
      basePeriodLabel:null,
      newLocation:null,
      locationsHistory:null,
      showAllColumns:false,
      showBy:"element",
      models:[
        {id:"result",color:"#000000", width:4},
        {id:"hrrr",color:"#0000ff"},
        {id:"nam",color:"#ffff00"},
        {id:"ndfd",color:"#ff00ff"},
        {id:"gfs",color:"#ff0000"},
        {id:"gfes",color:"#cfcfcf"},
        {id:"usblended",color:"#ffaaff"},
        {id:"vcusblended",color:"#00ffff", width:2},
        {id:"icond2",color:"#aaffaa"},
        {id:"iconeu",color:"#00ffff"},
        {id:"ecmwf",color:"#00ff00"},
        {id:"iconglobal",color:"#ffaaff"},
        {id:"gdps",color:"#ffffaa"},
        {id:"ukmo_global",color:"#ffffaa"},
      ],
      queryDefn:{
        startdate:"next10days",
        enddate:null,
        include:"hours,fcst,remote",
        options:"",
        elements:"datetime,datetimeEpoch,temp,tempmax,tempmin,precip,precipprob,snow,snowdepth,windspeed,winddir,pressure,stations",
        unitGroup:"us",
      },
      queryData:null,
      
    }
  },
  methods:{
    showSum(element) {
      return ["precip","snow"].includes(element);
    },
    formatEpochTime(epochTime) {
      return VcDateUtils.formatDateTime2(epochTime);
    },
    format(value,decimals,separators) {
      decimals=(decimals>=0)?decimals:1;
      if (!Number.isFinite(value) || value===Number.MIN_VALUE || value===Number.MAX_VALUE) return "-";

      if (separators) {
        return value.toLocaleString('en-US', {maximumFractionDigits:decimals});
      }
      return value.toFixed(decimals);
    },
    refreshData(model) {
      let me=this;

      if (!model) {

        me.queryData={};

        me.models.forEach(function(d) {
          me.refreshData(d);
        });
        return;
      }


      let queryDefn=JSON.parse(JSON.stringify(me.queryDefn));

      if (model.id && model.id!=='result') {
        queryDefn.forecastDataset=model.id;
      }

      
      vcCommunicator.retrieveTimelineData(queryDefn, me.selectedLocation.location, null, "json", true,false)
        .then(response => {
          response.model=model;
          me.queryData[model.id]=response;
        }).catch((error) => {
          me.errorMessage=error;
      });
    },
    setDateRange(startPeriod, endPeriod) {
      
      let me=this;
     
      me.queryDefn.startdate=startPeriod;
      me.queryDefn.enddate=endPeriod;
      me.refreshData();
    },
   

    setLocation(newLocation) {
      
      var me=this;
      if (newLocation) {
        me.selectedLocation=newLocation;
      } else {
        me.selectedLocation={
          location:me.newLocation,
          name:null,
        };
      }
      
      me.newLocation=null;
      me.refreshData();
    },
    
    setUnitGroup(unitGroup) {
      var me=this;
      me.unitGroup=unitGroup
      //VcLocationsStorage.setUnitGroup(me.unitGroup);
      me.refreshData();
    },
    refreshLocationsHistory() {
      this.locationsHistory=VcLocationsStorage.getLocations();
    },
    tableRows(table) {
      let me=this;
      if (!table || !table.days || !table.days.length) return [];
      if (me.isHours) {
        return table.days.reduce(function(a,d) {
          if (d && d.hours && d.hours.length) {
           // d.hours.forEach(h=> {
            
           // })
            a=a.concat(d.hours);
          }
          return a;
        },[])
      } else {
        return table.days;
      }
      
    },
    refreshComparisonChart() {
      let me=this;

      if (!me.queryData || !me.viewElement) return;
      let element=me.viewElement.element;

      var svg = d3.select(".comparisonchart").select("svg");
        
      if (!svg || !svg.node()) return;

      var rect=svg.node().getBoundingClientRect();
  
        
      let margin = {
          top: 10,
          right: 30,
          bottom: 20,
          left: 30
        },
        width = rect.width - margin.left - margin.right,
        height =rect.height - margin.top - margin.bottom;
      
      let tables=me.viewElement.models;
      let tableRows=tables.map(function(d) {
        //let rows= me.tableRows(d);
        //let dates=Object.keys(d);
        let dates=me.viewElement.dates;
        let rows=dates.map(function(d1) {
          return {datetimeEpoch:+d1, value:d[d1]}
        })

        rows.model=d.model;
        return rows;
      });
      
      let extents=tableRows.reduce(function([extentMinTime, extentMaxTime, extentMinElement, extentMaxElement], table) {
              const [minTime, maxTime] = d3.extent(table, function(d) {
                return d.datetimeEpoch;
              });

              const [minElement, maxElement] = d3.extent(table, function(d) {
                return d.value;
              });

              return [
                d3.min([extentMinTime, minTime*1000]),
                d3.max([extentMaxTime, maxTime*1000]),
                d3.min([extentMinElement, minElement]),
                d3.max([extentMaxElement, maxElement]),
              ];
            },[Infinity, -Infinity, Infinity, -Infinity] )


      //time axis
      let x = d3.scaleTime().range([0, width])
        .domain([ extents[0], extents[1] ]);
      /*
      let x = d3.scaleLinear()
          .range([0, width])
          .domain([ extents[0], extents[1] ]);
      */
      let yextentbuffer=(extents[3]-extents[2])/2; 
      let y = d3.scaleLinear()
         .range([height, 0])
         .domain([ extents[2]-yextentbuffer, extents[3]+yextentbuffer ]);

      let g;
      if (svg.select("g").empty())  {
          g = svg.append("g")
            .attr("clip-path","url(#chart)")
            .attr("class", "chartcontainer");
          g=g.append("g")
            .attr("class", "chart");
            
          g.attr("transform", "translate(" + margin.left + "," + margin.top + ")");
          
          svg.append("g")			
            .attr("class", "time-axis")
          svg
            .append("g")
            .attr("class", "y-axis")
    

          svg.append("clipPath")
            .attr("id", "chart")
            .append("rect")
              .attr("class", "clippath");
        } else {
          g=svg.select(".chart");
          g.attr("transform", "translate(" + margin.left + "," + margin.top + ")");
        }

        svg.select(".clippath")
            .attr("x",margin.left)
            .attr("y", margin.top)
            .attr("height",height)
            .attr("width",width)

        tableRows.forEach(function(table, index) {
          if (!table || !table.model) return;
          let modelLine = d3.line()
            .defined(function(d) { return d.value;})
            .x(function(d) { return x(d.datetimeEpoch*1000); })
            .y(function(d) { return y(d.value); }) 
            .curve(d3.curveMonotoneX);


          let u=g.selectAll("."+table.model.id+"line")
            .data([table]);
          
          u.enter()
            .append("path")
            .attr("class", table.model.id+"line modelline") 
            .style("stroke", table.model.color)
            .style("stroke-width", table.model.width || 1)
            .merge(u)
            .datum(table) 
            .attr("d", modelLine); 
        });

        
        svg.select(".time-axis").attr("transform", "translate("+margin.left+","+(height+margin.top)+")")
            .call(d3.axisBottom(x)
               .tickSize(-5)
               .tickFormat(function(d) {
                      return VcDateUtils.formatDateTime2(d);
                  })
            )

        svg.select(".y-axis").attr("transform", "translate("+margin.left+","+margin.top+")")
          .call(d3.axisLeft(y ).ticks(5));


        me.setUpTooltip(d3.select(".comparisonchart"),margin, tableRows,x,height, element);
        /*
        var u=d3.select(".comparisonchart .legend").selectAll(".item")
                .data(legendItems);
              u.exit().remove();

              var g=u.enter()
                .append("div")
                  .attr("class", "item")

              g.append("div")
                  .attr("class", function(d) {return "rect "+d.class;})

              g.append("div")
                  .text(function(d) {return d.label;})
        */
    },

     setUpTooltip(container,margin, tableRows,x,height, element) {
      var me=this;
      var svg=container.select("svg");
      var tooltip=container.select(".tooltip");

      var showHandler=function(event) {
        var x0 =(d3.pointer(event)[0]-margin.left);
        var y0 =(d3.pointer(event)[1]-margin.top);

        x0=Math.floor(x0);
        let datetime=x.invert(x0);
        let requiredDateTimeEpoch=3600;
        if (!me.isHours) {
           date.setHours(0);
           requiredDateTimeEpoch*=24;
        }
        datetime.setMinutes(0, 0, 0);
        let dateTimeEpoch=datetime.getTime()/1000;
        let html="<div class='h6 py-0 my-1'>"+VcDateUtils.formatDateTime2(datetime)+"</div>";


        let modelValues=[];
        tableRows.forEach(function(table) {
          let row=table.reduce(function(a, d) {
            let dateTimeDelta=d.datetimeEpoch-dateTimeEpoch;

            return a || (dateTimeDelta>=0 && dateTimeDelta<requiredDateTimeEpoch && d);
          }, null);
          let val=(row && row.value) ;
          if (!val && val!==0) return;
          //html+=`<div class=''>${table.model.id}:${me.format(val)}</div>`;
          modelValues.push({
            id:table.model.id,
            val:val,
          })
        });
        if (!modelValues || !modelValues.length) return;
        modelValues.sort((a, b) => b.val-a.val )

        const stats=modelValues.reduce((a,d)=>{
          //return a || (d.id==='result' && d.val);
          if (d.val>a.max) a.max=d.val;
          if (d.val<a.min) a.min=d.val;
          if (d.id==='result') a.result=d.val;
          return a 
        }, {
          max:-1000000000, min:1000000000, result:NaN
        });

        
        let hasFoundEqual=false, hasFoundLess=false;
        modelValues.forEach(d=>{
          let delta=d.val-stats.result;
          let deltaTxt="";
          if (delta>0) {
            deltaTxt=`(+${me.format(delta)})`;
          } else  if (delta<0) {
            deltaTxt=`(${me.format(delta)})`;
          } 
          let clz="";
          if (!hasFoundEqual && delta===0) {
            hasFoundEqual=true;
            clz+=" pt-3";
          }

          if (!hasFoundLess && delta<0) {
            hasFoundLess=true;
            clz+=" pt-3";
          }

          if (d.id==='result') {
             html+=`<div class='result ${clz}'>${me.format(d.val)}</div>`;
          } else {
             html+=`<div class=' ${clz}'>${d.id}: ${me.format(d.val)} ${deltaTxt}</div>`;
          }

         
        });
        html+=`<div class='range pt-3'>${me.format(stats.min)} - ${me.format(stats.max)}</div>`;

        y0=y0<height/2?height/2:0;
        me.showTooltip(x0+margin.left,y0, tooltip,html );

       
      }
      svg.on("mousemove", function(event) {
          showHandler(event);
        })
        .on("touchstart", function(event) {
          showHandler(event);
          event.preventDefault();
        })
       svg.on("mouseout", function() {
          me.hideTooltip(tooltip);
        })
        .on("touchend", function(event) {
          me.hideTooltip(tooltip);
        })
    },
    showTooltip(focusX, focusY, tooltip, html) {
        if (!html) html="";

       
       
        tooltip.style("visibility", "visible")
                .style("opacity", "1")
                .style("left", (focusX) + "px")
                .style("top",(focusY+5) + "px");
                       
         tooltip=tooltip.select(".contents")
         tooltip.html(html);    

         

        return tooltip;
    },

    hideTooltip(tooltip) {
      tooltip.style("visibility", "hidden")
    },
  },
  computed:{
   
    isHours() {
      let me=this;
      return me.queryDefn && me.queryDefn.include && me.queryDefn.include.indexOf("hours")!==-1;
    },
    elementTables() {
      let me=this;
      let tables=me.tables;
      me.viewElement=null;
      if (!tables) return [];

      let elements= me.queryDefn.elements.split(",");
      const hiddenElements=["datetime", "datetimeEpoch","stations"];
      elements=elements.filter(function(d) {
        return !hiddenElements.includes(d);
      });

     

      let retVal= elements.reduce(function(a, element) {
        let elementTable={
          element:element,
          models:[],
          dates:[]
        };

        let dateTimeMeans={};
      /*
        let summaryTable={};
        summaryTable["model"]={
          "id":"summary",
          "color":"#000000",
        };
      
       
      */      

        elementTable.models=
          tables.reduce(function(a1, table) {


            let rows=me.tableRows(table);
            let elementRows=rows.reduce(function(a2, row, i) {

              if (i===0) {
                a2.count=0;
                a2.max=Number.MIN_VALUE;
                a2.min=Number.MAX_VALUE;
                a2.sum=0;
              }
              let value=row[element];
              if (!elementTable.dates.includes(row.datetimeEpoch)) {
                elementTable.dates.push(row.datetimeEpoch)
              }
              a2[row.datetimeEpoch]=value
             

          
              if (Number.isFinite(value)) {
                a2.count++;
                a2.sum+=value;
                if (value>a2.max) a2.max=value;
                if (value<a2.min) a2.min=value;

                 
                if (!dateTimeMeans[row.datetimeEpoch]) {
                  dateTimeMeans[row.datetimeEpoch]={count:1, total:value};
                } else {
                  dateTimeMeans[row.datetimeEpoch].count++;
                  dateTimeMeans[row.datetimeEpoch].total+=value;
                }

                //summaryTable[row.datetimeEpoch]=dateTimeMeans[row.datetimeEpoch].total/dateTimeMeans[row.datetimeEpoch].count;

              }


              return a2;
            },{});
            elementRows["model"]=table && table.model;
            a1.push(elementRows);
            return a1;
          }, [])
        
        //elementTable.models.push(summaryTable);
        a.push(elementTable);
        return a;
      }, []);
     
      me.viewElement=retVal && retVal[0];

      return retVal;
    },
    modelIds() {
      let me=this;
      return me.models.map(function(d) {
        return d.id;
      });
    },
    tables() {
      let me=this;
      if (!me.queryData) return [];

      let retVal=[];

      //let models=Object.keys(me.queryData);
      const models=me.modelIds;

      models.forEach(function(model) {
        retVal.push(me.queryData[model]?me.queryData[model] : null);
      });
      return retVal;

    },
    columns() {
      let me=this;
      let rawColumns= me.queryDefn.elements.split(",");
      const hiddenCols=["datetimeEpoch","stations"];

      return rawColumns.filter(function(d) {
        return me.showAllColumns || !hiddenCols.includes(d);
      });
    },

    showDateRangeChooser() {
      return true;
    },
    hasLocationsHistory() {
      return this.locationsHistory && this.locationsHistory.length;
    },
  },
  watch: {
    queryData:{
        handler:function(newValue,oldValue) {
          this.refreshComparisonChart();
        },
        deep: true
    },
    viewElement:{
        handler:function(newValue,oldValue) {
          this.refreshComparisonChart();
        },
        deep: true
    },
  },
   unmounted() {
    var me=this;
  },
  mounted() {
     var me=this;
   
    var vcCommunicator=window.vcCommunicator;
    if (!vcCommunicator) {
      console.log("No vcCommunicator");
      return;
    }
    me.sessionId=vcCommunicator.sessionId;
    me.sessionState=vcCommunicator.sessionState;
    vcCommunicator.addHandler('createsession', function (sessionId,sessionState) {
      me.sessionId=sessionId;
      me.sessionState=sessionState;
    
    
    });
     vcCommunicator.addHandler('terminatesession', function () {
       me.sessionId=null;
       me.sessionState=null;
    });

   
    
    
  },
  components: {
    DateRangeChooser,
    CommonModals
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .old {
      font-style: italic;
      opacity: 0.9;
  }
  .table-striped tbody  .error {
    font-weight: bold;
  
  }
  .table-striped tbody .error td {
      background-color: rgb(245, 212, 212) !important;
  }

  .comparisonchart {
      background-color: #fff;
      position:relative;
  }

  .comparisonchart :deep() .modelline {
      stroke:rgb(81, 82, 81);
      fill:none;
  }
  

 .tooltip {
    background-color: white;
    border: solid;
    border-width: 2px;
    border-radius: 5px;
    padding: 5px;
    position: absolute;
    transform: translate(-50%, 0%);
    pointer-events: none;
    line-height: 13px;
  }
  .tooltip .contents {
  
  }
  .tooltip .contents  :deep() .range {
    font-weight: bold;
    font-size: 1.1em;
  }

  .tooltip .contents  :deep() .result {
    font-weight: bold;
    font-size: 1.2em;
  }
  
  .tooltip * {
    text-align: center;
  }

</style>